import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this tied to a specific wrestling program or brand?',
  a: "No. It uses standard folkstyle terms written in plain English and works alongside whatever certification you hold. It isn't affiliated with any governing body, club brand or method, and it doesn't replace your training."
}, {
  q: "It's a PDF. How will I know what the move looks like?",
  a: "Every technique comes with its position, the key steps, short cues, easier and harder versions and the most common error with its fix, next to simple overhead diagrams with direction arrows. It's a written system, not a video course, and it's built so you can explain each position even if you never wrestled it yourself."
}, {
  q: 'I already have free practice plans. Why would I need this?',
  a: 'Free plans are usually single practices or blank templates. This gives you the order: what to run each day of the season, with games, conditioning and two tracks for a mixed room. Plenty of coaches add drills they already love into the system.'
}, {
  q: 'Do I have to start at Practice 01?',
  a: 'No. Each volume works on its own, with its own clock, warm-up games, finishers and worksheets, so a coach who starts midseason can open Volume 4 without having seen Volume 1.'
}, {
  q: "My practices aren't 90 minutes. Will it still work?",
  a: 'Every practice comes with a 90-minute clock and a marked 60-minute cut, plus a short version for the day before a meet. Bonus 01, the Week Adapter, shows how to fit 3, 4 or 6-day weeks and 45 or 120-minute sessions.'
}, {
  q: 'Is it folkstyle or freestyle?',
  a: "Folkstyle-first, the style used in U.S. schools, with a short Freestyle Note on every practice. Bonus 05 is a Freestyle Season Guide for coaches in Canada, the UK and Australia. Always check your federation's current rulebook."
}, {
  q: 'Does it work for youth wrestlers?',
  a: 'Yes. Every practice has a Youth Note for ages 6 to 12, and the Two-Track system lets a room of mixed ages and experience practice together.'
}, {
  q: "I've never wrestled. Can I use it?",
  a: 'The pack was written with you in mind: Volume 1 includes folkstyle scoring explained for new coaches and a page on illegal and potentially dangerous holds, and every practice spells out the position, the steps and the cues.'
}, {
  q: 'Does it cover weight, injuries or safety?',
  a: "There is no weight-management content. Higher-risk moves carry a Safety Cue, and the pack points you to your state association's rules and your athletic trainer for skin checks, concussion protocol and anything medical."
}, {
  q: 'Is it 90 completely different practices?',
  a: 'Every practice uses the same six-block order, so your room always knows the routine. The position of the day, drills, games and finishers change, and later volumes chain moves together that earlier ones built.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Landscape PDFs that read well on a phone at the edge of the mat and print cleanly for your clipboard.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-cream text-ink" data-id="element-79" data-mp="3idkaj9uy4tk3">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-80" data-mp="3nd6yad8ehs75">
        <div className="text-center" data-id="element-81" data-mp="3nft3i67tjvm7">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-82" data-mp="3res4xgucda8w">
            Before you buy
          </p>
          <h2 id="faq-heading" className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-83" data-mp="8h2phdli3fz">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-84" data-mp="220m038dv5sy3">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-cream-dark bg-white" data-id="element-85" data-mp="11rcj60mrcmw5" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-semibold text-plum focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-deep" data-id="element-86" data-mp="1gnlit3ak9293">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-87" data-mp="sz2ainrigph0" /> : <PlusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-88" data-mp="56v8p930nqa7" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-89" data-mp="2gogkash3d8t8">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}